// extracted by mini-css-extract-plugin
module.exports = {"price":"product-type_price_2F0PU","count":"product-type_count_CqL8d"};